const LangEgiftHeaderMegaMenu = {
	"mm.coffee.OurCoffees": ["Our Coffees", "Cà phê của Chúng tôi"],
	"mm.coffee.OurCoffees.WholeBeanCoffee": ["Whole Bean Coffee", "Cà phê Nguyên Hạt"],
	"mm.coffee.OurCoffees.ViewAllCoffees": [
		"View All Coffees",
		"Xem Tất cả các loại Cà phê",
	],
	//
	"mm.coffee.FindYourPerfectCoffee": [
		"Find Your Perfect Coffee",
		"Tìm loại Cà phê Hoàn hảo của Bạn",
	],
	//
	"mm.coffee.Espresso": ["Espresso", "Espresso"],
	"mm.coffee.Espresso.TheIngredients": ["The Ingredients", "Thành phần"],
	"mm.coffee.Espresso.TheBestEquipment": ["The Best Equipment", "Thiết bị Tốt nhất"],
	"mm.coffee.Espresso.WhoMakesIt": ["Who Makes It", "Nhân viên Pha chế Cà phê"],
	//
	"mm.coffee.HowToBrewGreatCoffee": ["How to Brew Great Coffee", "làm thế nào để nấu"],
	"mm.coffee.HowToBrewGreatCoffee.CoffeePress": ["CoffeePress", "báo chí cà phê"],
	"mm.coffee.HowToBrewGreatCoffee.PourOver": ["Pour-Over", "đổ giao"],
	"mm.coffee.HowToBrewGreatCoffee.IcedPourOver": ["Iced Pour-Over", "đá đổ giao"],
	"mm.coffee.HowToBrewGreatCoffee.CoffeeBrewer": ["Coffee Brewer", "bia cà phê"],
	//
	"mm.coffee.EthicalSourcing": ["Ethical Sourcing", "Tìm nguồn Cung ứng có Đạo đức"],
	"mm.coffee.EthicalSourcing.Coffee": [
		"Coffee",
		"Cà phê được Vun trồng có Trách nhiệm",
	],
	"mm.coffee.EthicalSourcing.CoffeeQuality": ["Coffee Quality", "Chất lượng cà phê"],
	"mm.coffee.EthicalSourcing.FarmerSupport": ["Farmer Support", "Hỗ trợ Nông dân"],
	//
	"mm.coffee.LearnMore": ["Learn More", "Tìm hiểu Thêm "],
	"mm.coffee.LearnMore.StarbucksRoastSpectrum": [
		"Starbucks Roast Spectrum",
		"Dòng sản phẩm Cà phê Rang Starbucks",
	],
	"mm.coffee.LearnMore.FlavorsInYourCup": [
		"Flavors in Your Cup",
		"Những hương vị trong Cốc cà phê của bạn",
	],
	"mm.coffee.LearnMore.CoffeeFAQ": ["Coffee FAQ", "Câu hỏi Thường Gặp về Cà phê"],
	//
	"mm.coffee.LookingForCoffeeBeverages": [
		"Looking for Coffee Beverages?",
		"Bạn đang tìm kiếm các loại Đồ uống Cà phê? ",
	],
	"mm.coffee.LookingForCoffeeBeverages.Drinks": ["Drinks", "Thức uống"],
	//
	"mm.coffee.side.Title": ["Blonde Roast", "Blonde Roast"],
	"mm.coffee.side.Body": [
		"Mild and mellow, the lighter roast perfected.",
		"Nhẹ và ngọt dịu, loại cà phê rang qua hoàn hảo.",
	],
	//
	//
	"mm.menu.Drinks": ["Drinks", "Thức uống"],
	"mm.menu.Drinks.EspressoBeverages": ["Espresso Beverages", "Thức uống Espresso"],
	"mm.menu.Drinks.ChocolateBeverages": ["Chocolate Beverages", "Thức uống với Sôcôla"],
	"mm.menu.Drinks.FrappuccinoBlendedCoffee": [
		"Frappuccino® Blended Coffee",
		"Cà phê Xay Frappuccino®",
	],
	"mm.menu.Drinks.FrappuccinoBlendedCream": [
		"Frappuccino® Blended Cream",
		"Kem Trộn Frappuccino®",
	],
	"mm.menu.Drinks.BrewedTea": ["Brewed Tea", "Trà pha"],
	//
	"mm.menu.Food": ["Food", "Thức ăn"],
	"mm.menu.Food.Bakery": ["Bakery", "Bánh"],
	"mm.menu.Food.Muffins": ["Muffins", "Bánh Muffin"],
	"mm.menu.Food.Cookies": ["Cookies", "Bánh cookie"],
	"mm.menu.Food.Cakes": ["Cakes", "Bánh Ngọt"],
	"mm.menu.Food.ColdSandwiches": ["Cold Sandwiches", "Bánh mì sandwiches"],
	//
	"mm.menu.LookingForCoffeeToDrinkAtHome": [
		"Looking for coffee to drink at home?",
		"Bạn đang tìm kiếm Cà phê để thưởng thức tại Nhà? ",
	],
	"mm.menu.LearnAboutTheStarbucksRoastSpectrum": [
		"Learn About the Starbucks Roast Spectrum",
		"Tìm hiểu về Dòng sản phẩm cà phê rang Starbucks Roast",
	],
	"mm.menu.LearnAboutTheStarbucksRoastSpectrum.Coffee": ["Coffee", "Cà phê"],
	//
	"mm.menu.side.Title": ["Real Food, Simply Delicious", "Đồ ăn Thực thụ, Cực Ngon"],
	"mm.menu.side.Body": [
		"See the food choices we have in store.",
		"Xem những lựa chọn món ăn mới trong cửa hàng của chúng tôi.",
	],
	//
	//
	"mm.coffeehouse.CoffeemasterProgram": [
		"Coffeemaster Program",
		"Chương trình Chuyên gia cà phê",
	],
	"mm.coffeehouse.OnlineCommunity": ["Online Community", "Cộng đồng Trực tuyến"],
	"mm.coffeehouse.StoreDesign": ["Store Design", "Thiết kế Cửa hàng"],
	"mm.coffeehouse.Merchandise": ["Merchandise", "Thương mại"],
	"mm.coffeehouse.Merchandise.Drinkware": ["Drinkware", "Drinkware"],
	"mm.coffeehouse.Merchandise.Machines": ["Machines", "Machines"],
	"mm.coffeehouse.Merchandise.Accessories": ["Accessories", "Accessories"],
	//
	"mm.coffeehouse.LookingForSomethingElse": [
		"Looking for Something Else?",
		"Bạn đang tìm kiếm Điều gì Khác?",
	],
	"mm.coffeehouse.Drinks": ["Drinks", "Thức uống"],
	"mm.coffeehouse.AboutUs": ["About Us", "Giới thiệu về chúng tôi"],
	//
	"mm.coffeehouse.side.Title": [
		"Our Coffee Brings People Together",
		"Cà phê của chúng tôi đưa mọi người lại gần nhau",
	],
	"mm.coffeehouse.side.Body": [
		"Have fun, dream big and connect with friends.",
		"Vui chơi, mơ giấc mơ lớn và kết nối với bạn bè.",
	],
	//
	//
	"mm.responsibility.EthicalSourcing": [
		"Ethical Sourcing",
		"Tìm nguồn Cung ứng có Đạo đức",
	],
	"mm.responsibility.EthicalSourcing.CoffeeSourcing": [
		"Coffee Sourcing",
		"Hỗ trợ Nông dân",
	],
	"mm.responsibility.EthicalSourcing.FarmerSupport": [
		"Farmer Support",
		"Tìm nguồn Cung ứng Cà phê",
	],
	"mm.responsibility.EthicalSourcing.TeaSourcing": [
		"Tea Sourcing",
		"Tìm nguồn Cung ứng Trà",
	],
	"mm.responsibility.EthicalSourcing.CocoaSourcing": [
		"Cocoa Sourcing",
		"Tìm nguồn Cung ứng Ca cao",
	],
	//
	"mm.responsibility.Environment": ["Environment", "Môi trường"],
	"mm.responsibility.Environment.Recycling": ["Recycling", "Tái chế"],
	"mm.responsibility.Environment.Energy": ["Energy", "Năng lượng"],
	"mm.responsibility.Environment.Water": ["Water", "Nước"],
	"mm.responsibility.Environment.GreenBuilding": ["GreenBuilding", "Công trình Xanh"],
	"mm.responsibility.Environment.ClimateChange": ["Climate Change", "Biến đổi Khí hậu"],
	//
	"mm.responsibility.LookingForStarbucksInformation": [
		"Looking for Starbucks Information?",
		"Bạn đang tìm kiếm Thông tin về Starbucks?",
	],
	"mm.responsibility.AboutUs": ["About Us", "Giới thiệu về Chúng tôi"],
	"mm.responsibility.Coffee": ["Coffee", "Cà phê"],
	//
	"mm.responsibility.side.Title": [
		"Community Involvement",
		"Sự tham gia của Cộng đồng",
	],
	"mm.responsibility.side.Body": [
		"We’re inspiring partners (employees) and customers to get involved in their communities.",
		"Chúng tôi khuyến khích cộng sự (nhân viên) cũng như khách hàng tham gia cộng đồng của họ.",
	],
	//
	//
	"mm.aboutus.OurHeritage": ["Our Heritage", "Di sản"],
	"mm.aboutus.OurCompany": ["Our Company", "Công ty"],
	"mm.aboutus.OurCompany.MissionStatement": [
		"Mission Statement",
		"Tuyên bố về Sứ mệnh",
	],
	"mm.aboutus.OurCompany.BusinessEthicsAndCompliance": [
		"Business Ethics and Compliance",
		"Đạo đức và Tuân thủ trong Kinh doanh",
	],
	"mm.aboutus.OurCompany.DiversityAtStarbucks": [
		"Diversity at Starbucks",
		"Sự đa dạng tại Starbucks",
	],
	"mm.aboutus.OurCompany.OnlinePolicies": ["Online Policies", "Chính sách Trực tuyến"],
	//
	"mm.aboutus.CareerCenter": ["Career Center", "Cơ hội nghề nghiệp"],
	//
	"mm.aboutus.LookingForStoreLocations": [
		"Looking for Store Locations?",
		"Bạn đang tìm kiếm Vị trí Cửa hàng?",
	],
	"mm.aboutus.CustomerService": ["Customer Service", "Dịch vụ Khách hàng"],
	"mm.aboutus.StoreLocator": ["Store Locator", "Bộ định vị Cửa Hàng"],
	//
	"mm.aboutus.side.Title": ["A Different Kind of Company", "Một Loại Công ty Khác"],
	"mm.aboutus.side.Body": [
		"Our mission to inspire and nurture the human spirit – one person, one cup, and one neighborhood at a time.",
		"Sứ mệnh của chúng tôi là khơi nguồn cảm hứng và nuôi dưỡng tinh thần con người – một người, một cốc cà phê và một tình hàng xóm vào một thời điểm.",
	],
	//
	//
	"mm.card.ManageYourCard": ["Manage Your Card", "Quản Lý Tài Khoản"],
	"mm.card.ManageYourCard.LoginCreateAnAccount": [
		"Login/Create An Account",
		"Đăng nhập/Đăng ký tài khoản mới",
	],
	"mm.card.ManageYourCard.ViewTransactions": ["View Transactions", "Lịch sử giao dịch"],
	"mm.card.ManageYourCard.ReportLostStolen": ["Report Lost/Stolen", "Báo mất thẻ"],
	//
	"mm.card.LearnMore": ["Learn More", "Thông Tin Khác"],
	"mm.card.LearnMore.StarbucksRewards": ["Starbucks Rewards™", "Starbucks Rewards™"],
	"mm.card.LearnMore.ProgramTermsAndConditions": [
		"Program Terms and Conditions",
		"Điều kiện và điều khoản chương trình",
	],
	"mm.card.LearnMore.PrivacyStatement": [
		"Privacy Statement",
		"Chính sách về quyền riêng tư",
	],
	"mm.card.LearnMore.CardFaqs": [
		"CardFAQs",
		"Câu hỏi thường gặp chương trình Starbucks Rewards™",
	],
	//
	"mm.card.StarbuckseGifting": ["Starbucks eGifting", "Thẻ quà tặng điện tử"],
	"mm.card.StarbuckseGifting.SendeGiftingNow": [
		"Send eGifting now",
		"Gửi thẻ quà tặng ngay",
	],
	//
	"mm.card.LookingForStoreLocations": [
		"Looking for Store Locations?",
		"Đang tìm kiếm vị trí cửa hàng",
	],
	"mm.card.StoreLocator": ["Store Locator", "Bộ định vị Cửa hàng"],
	//
	"mm.card.side.Title": [
		"Earn rewards with every visits.",
		"Nhận ngôi sao điểm thưởng cho mỗi chi tiêu tại Starbucks.",
	],
	"mm.card.side.Body": [
		"Join Starbucks Rewards™ today",
		"Đăng ký  Starbucks Rewards™  ngay hôm nay",
	],
}

export default LangEgiftHeaderMegaMenu



// WEBPACK FOOTER //
// ./src/resources/modules/LangEgiftHeaderMegaMenu.js